/**
 * @summary Administrador global do sistema.
*/
const GLOBAL_ADM = "GlobalAdministrator";

/**
 * @summary Administrador de uma empresa do sistema.
*/
const COMPANY_ADM = "CompanyAdministrator";

/**
 * @summary Equipamento do sistema.
*/
const DATA_COLLECTOR = "PrivilegesDataCollector";

/**
 * @summary Usuário de demonstração do sistema.
*/
const DEMO = "Demo";

/**
 * @summary Usuário comum de acesso ao sistema.
*/
const VIEW_MONITORING_ELEMENTS = "PrivilegesViewMonitoringElements";

export default {
	GLOBAL_ADM,
	COMPANY_ADM,
	DATA_COLLECTOR,
	DEMO,
	VIEW_MONITORING_ELEMENTS
};